import { BadgeChipX } from 'framework/components/chips/BadgeChipX';
import { IPurchasesQueryMetadata, PurchasesPrefilter } from 'gen/ApiClient';
import React from 'react';

export const createPurchasesPrefilterBadgeChipXRecord = (metadata: IPurchasesQueryMetadata): Record<PurchasesPrefilter, React.ReactNode> => {
	return {
		All: undefined,
		Overdue: metadata.countOverdue > 0 && (
			<BadgeChipX
				value={metadata.countOverdue}
				color='warning'
			/>
		),
		NotPaid: metadata.countNotPaid > 0 && (
			<BadgeChipX
				value={metadata.countNotPaid}
				color='primary'
			/>
		),
	};
};
